export default __webpack_public_path__ + "RomainCordier.526b83e.jpg";